import { Plugin } from 'ckeditor5/src/core';
import { Widget, toWidget } from 'ckeditor5/src/widget';
import { OpenscopInsertCommand } from './OpenscopInsertCommand';
export default class OpenscopIconsEditing extends Plugin {
    static get requires() {
        return [Widget];
    }
    init() {
        this._defineSchema();
        this._defineConverters();
        this._defineCommands();
    }
    _defineSchema() {
        const schema = this.editor.model.schema;
        const allowAttributes = ['icon'];
        schema.register('icon', {
            isObject: true,
            isInline: true,
            inheritAllFrom: '$inlineObject',
            allowWhere: '$text',
            allowAttributes
        });
    }
    _defineConverters() {
        const conversion = this.editor.conversion;
        conversion.for('upcast').elementToElement({
            model: (viewElement, { writer }) => {
                const element = writer.createElement('icon');
                const icon = viewElement.getAttribute('class');
                writer.setAttribute('icon', icon, element);
                return element;
            },
            view: {
                name: 'i',
                attributes: ['aria-hidden']
            }
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'icon',
            view: (modelElement, { writer: viewWriter }) => createIconView(modelElement, viewWriter)
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'icon',
            view: (modelElement, { writer: viewWriter }) => createIconWidgetView(modelElement, viewWriter)
        });
    }
    _defineCommands() {
        const editor = this.editor;
        const commands = editor.commands;
        commands.add('openscopInsert', new OpenscopInsertCommand(editor));
    }
}
function createIconView(modelElement, viewWriter) {
    return viewWriter.createContainerElement('i', { class: modelElement.getAttribute('icon'), 'aria-hidden': 'true' });
}
function createIconWidgetView(modelElement, viewWriter) {
    return toWidget(viewWriter.createContainerElement('i', {
        class: `${getIconClassName(modelElement)} ckeditor5-icons__widget`,
        'aria-hidden': 'true'
    }), viewWriter, { label: 'icon widget' });
}
function getIconClassName(modelElement) {
    return modelElement.getAttribute('icon');
}
